// extracted by mini-css-extract-plugin
export default {"link":"AA-z","disabled":"BA-z"};